<template>
    <div :class="`send-btn-container-${align}`">
        <button v-if="!isSpecial" id="container" class="send-btn" @click="sendForm($event)">
            <div class="btn-content">
                <span class="btn-text">{{ fieldLabel }}</span>
                <div class="btn-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <line x1="22" y1="2" x2="11" y2="13"/>
                        <polygon points="22,2 15,22 11,13 2,9"/>
                    </svg>
                </div>
            </div>
        </button>
        
        <!--betnano için özel tasarım-->
        <div class="nano-btn" v-else @click="sendForm($event)">
            <img src="../../../SpecialForm/assets/nanosendbtn.png" class="nano-img">
            <div class="label-overlay">{{ fieldLabel }}</div>
        </div>
    </div>
</template>

<script>
export default {
    name: "FormSendBtn",
    props: {
        fieldLabel: {
            type: String,
            default: "Send",
        },
        align: {
            type: String,
            default: "top",
        },
        formId: {
            type: String,
            required: true,
        },
        order: {
            type: Number,
            required: true,
        }
    },
    data() {
        return {
            isSpecial: false,
        };
    },
    methods: {
        sendForm(event) {
            console.log('🔴 SendBtn clicked:', {
                event: event?.type,
                isTrusted: event?.isTrusted,
                timeStamp: event?.timeStamp,
                target: event?.target?.tagName,
                currentTarget: event?.currentTarget?.tagName,
                detail: event?.detail,
                clientX: event?.clientX,
                clientY: event?.clientY
            });

            if (!event || !event.isTrusted) {
                console.log('❌ SendBtn: Güvenilir olmayan event, submit iptal ediliyor');
                return;
            }

            if (event.clientX === 0 && event.clientY === 0) {
                console.log('❌ SendBtn: Suspicious coordinates (0,0), submit iptal ediliyor');
                return;
            }

            console.log('✅ SendBtn: Geçerli user click, submit tetikleniyor');
            this.$emit("submit", { 
                triggeredByButton: true,
                userClick: true,
                timestamp: Date.now()
            });
        }
    },
    mounted() {
        console.log('🔴 SendBtn mounted:', {
            fieldLabel: this.fieldLabel,
            align: this.align,
            formId: this.formId,
            order: this.order,
            isSpecial: this.isSpecial,
            timestamp: new Date().toISOString()
        });

        const special = this.$route.query.special;
        if (special === "true") {
            this.isSpecial = true;
        }
    }
};
</script>

<style lang="scss" scoped>
// Container alignment sistemleri
.send-btn-container-left {
    display: flex;
    justify-content: flex-start;
    width: 100%;
    margin: 24px 0;
    font-family: var(--font-family);
}

.send-btn-container-right {
    display: flex;
    justify-content: flex-end;
    width: 100%;
    margin: 24px 0;
    font-family: var(--font-family);
}

.send-btn-container-top {
    display: flex;
    justify-content: center;
    width: 100%;
    margin: 32px 0;
    font-family: var(--font-family);
}

// Modern send button
.send-btn {
    position: relative;
    padding: 16px 32px;
    font-size: 16px;
    font-weight: 600;
    color: white;
    background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);
    border: none;
    border-radius: 12px;
    cursor: pointer;
    outline: none;
    overflow: hidden;
    transition: all 0.3s ease;
    min-width: 160px;
    backdrop-filter: blur(8px);
    box-shadow: 0 8px 32px rgba(44, 62, 80, 0.3),
                0 2px 8px rgba(0, 0, 0, 0.1);
    
    // Content wrapper
    .btn-content {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 12px;
        z-index: 2;
        
        .btn-text {
            font-family: var(--font-family);
            letter-spacing: 0.5px;
            transition: all 0.3s ease;
        }
        
        .btn-icon {
            width: 20px;
            height: 20px;
            transition: all 0.3s ease;
            
            svg {
                width: 100%;
                height: 100%;
            }
        }
    }
    
    // Ripple effect container (disabled)
    .btn-ripple {
        display: none;
    }
    
    // Hover efektleri
    &:hover {
        transform: translateY(-2px);
        background: linear-gradient(135deg, #1a252f 0%, #2c3e50 100%);
        box-shadow: 0 12px 48px rgba(44, 62, 80, 0.4),
                    0 4px 16px rgba(0, 0, 0, 0.15);
        
        .btn-content {
            .btn-text {
                transform: translateX(-2px);
            }
            
            .btn-icon {
                transform: translateX(4px) rotate(15deg);
            }
        }
    }
    
    // Active (basılı) durumu
    &:active {
        transform: translateY(0px);
        box-shadow: 0 4px 16px rgba(44, 62, 80, 0.3),
                    0 1px 4px rgba(0, 0, 0, 0.1);
    }
    
    // Focus durumu (keyboard navigation)
    &:focus-visible {
        outline: 3px solid rgba(44, 62, 80, 0.3);
        outline-offset: 2px;
    }
    
    // Loading state için (gelecekte kullanılabilir)
    &.loading {
        pointer-events: none;
        
        .btn-content {
            opacity: 0.7;
        }
    }
}

// Pulse animasyonu (unused)
/* @keyframes pulse {
    0%, 100% {
        opacity: 0.3;
        transform: scale(1);
    }
    50% {
        opacity: 0.7;
        transform: scale(1.05);
    }
} */

// Special nano button (korunuyor)
.nano-btn {
    position: relative;
    display: inline-block;
    width: 200px;
    height: 200px;
    text-align: center;
    cursor: pointer;
}

.nano-img {
    width: 100%;
    height: 80px;
    display: block;
}

.label-overlay {
    position: absolute;
    top: 20%;
    left: 45%;
    transform: translate(-50%, -50%);
    color: #fbb03a;
    font-weight: bold;
    text-align: center;
    font-family: sans-serif;
}

// Responsive tasarım
@media (max-width: 768px) {
    .send-btn-container-left,
.send-btn-container-right {
        justify-content: center;
        margin: 20px 0;
}

.send-btn {
        padding: 14px 28px;
        font-size: 15px;
        min-width: 140px;
        border-radius: 10px;
        
        .btn-content {
            gap: 10px;
            
            .btn-icon {
                width: 18px;
                height: 18px;
            }
        }
    }
}

// Küçük ekranlar için
@media (max-width: 480px) {
    .send-btn-container-left,
    .send-btn-container-right,
    .send-btn-container-top {
        margin: 16px 0;
    }
    
    .send-btn {
        padding: 12px 24px;
        font-size: 14px;
        min-width: 120px;
        border-radius: 8px;
        
        .btn-content {
            gap: 8px;
            
            .btn-icon {
                width: 16px;
                height: 16px;
            }
        }
    }
}

// Dark mode devre dışı - Her zaman açık tema kullan

// Erişilebilirlik için motion reduction
@media (prefers-reduced-motion: reduce) {
    .send-btn {
        transition: none;
        
        .btn-content,
        .btn-icon,
        .btn-text {
            transition: none;
            animation: none;
        }

    &:hover {
            transform: none;
        }
        
        &:active {
            transform: none;
        }
    }
}
</style>